/* Accueil Bellaziza V3.8 (11/10/2026) : héros défilant, onglets, sliders (barre + flèches), copie du code promo.
   Valeurs reprises de laredoute.it : 10 s par image du héros, glissement 300 ms. Pause au survol, au toucher, au clavier,
   quand la page est cachée, et toujours si l'utilisateur a demandé moins d'animations. */
(function () {
  if (window.bzV38) return; window.bzV38 = true;
  var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function glisser(p, a, duree) {
    if (reduit || !duree) { p.scrollLeft = a; return; }
    var de = p.scrollLeft, t0 = null; p.style.scrollSnapType = 'none';
    function pas(t) { if (t0 === null) t0 = t; var k = Math.min(1, (t - t0) / duree), e = 1 - Math.pow(1 - k, 3);
      p.scrollLeft = de + (a - de) * e; if (k < 1) requestAnimationFrame(pas); else p.style.scrollSnapType = ''; }
    requestAnimationFrame(pas);
  }

  /* Héros */
  function heros(s) {
    if (s.bzPret) return; s.bzPret = true;
    var p = s.querySelector('.bz-hero__piste'); if (!p) return;
    var sl = [].slice.call(p.children); if (sl.length < 2) return;
    var pts = [].slice.call(s.querySelectorAll('.bz-hero__points button')), pb = s.querySelector('.bz-hero__pause');
    var delai = parseInt(s.getAttribute('data-delai'), 10) || 10000, i = 0, t = null, arret = reduit, survol = false;
    function maj() { var n = Math.round(p.scrollLeft / Math.max(1, p.clientWidth)); i = n;
      pts.forEach(function (b, k) { b.setAttribute('aria-current', k === n ? 'true' : 'false'); });
      sl.forEach(function (x, k) { if (k === n) x.removeAttribute('inert'); else x.setAttribute('inert', ''); }); }
    function aller(n) { var boucle = n >= sl.length; i = (n + sl.length) % sl.length; glisser(p, sl[i].offsetLeft, boucle ? 0 : 300); }
    function stop() { clearInterval(t); t = null; }
    function jouer() { stop(); if (arret || survol || document.hidden) return; t = setInterval(function () { aller(i + 1); }, delai); }
    var to; p.addEventListener('scroll', function () { clearTimeout(to); to = setTimeout(maj, 90); }, { passive: true });
    pts.forEach(function (b, k) { b.addEventListener('click', function () { aller(k); jouer(); }); });
    if (pb) pb.addEventListener('click', function () { arret = !arret; pb.setAttribute('aria-pressed', arret ? 'true' : 'false');
      pb.setAttribute('aria-label', arret ? 'Relancer le défilement' : 'Mettre le défilement en pause'); arret ? stop() : jouer(); });
    s.addEventListener('mouseenter', function () { survol = true; stop(); });
    s.addEventListener('mouseleave', function () { survol = false; jouer(); });
    s.addEventListener('focusin', function () { survol = true; stop(); });
    s.addEventListener('focusout', function () { survol = false; jouer(); });
    p.addEventListener('touchstart', stop, { passive: true });
    p.addEventListener('touchend', function () { setTimeout(jouer, 4000); }, { passive: true });
    document.addEventListener('visibilitychange', jouer);
    maj(); jouer();
  }

  /* Sliders : marge d'accroche en pixels (la 1re carte reste alignée sur le titre), barre de progression, flèches */
  function glisse(c) {
    if (c.bzPret) return; c.bzPret = true;
    var g = c.querySelector('.bz-rangee, .bz-macros'); if (!g) return;
    var b = c.querySelector('.bz-glisse__barre i'), fl = c.querySelectorAll('.bz-gf'), lw = 0;
    function maj() { var sw = g.scrollWidth, cw = g.clientWidth, sl = g.scrollLeft;
      c.classList.toggle('is-statique', sw <= cw + 4);
      if (b && sw > 0) { b.style.setProperty('--w', (cw / sw * 100) + '%'); b.style.setProperty('--x', (sl / cw * 100) + '%'); }
      if (fl.length === 2) { fl[0].disabled = sl < 4; fl[1].disabled = sl + cw >= sw - 4; } }
    function bord() { var cw = g.clientWidth; if (!cw) { lw = 0; return; }
      g.style.scrollPaddingInline = getComputedStyle(g).paddingLeft; if (!lw) g.scrollLeft = 0; lw = cw; maj(); }
    fl.forEach(function (x) { x.addEventListener('click', function () {
      g.scrollBy({ left: +x.getAttribute('data-d') * g.clientWidth * 0.8, behavior: reduit ? 'auto' : 'smooth' }); }); });
    g.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', bord);
    if ('ResizeObserver' in window) new ResizeObserver(bord).observe(g);
    bord();
  }

  /* Vidéos des artisans (12/10) : la source n'est posée qu'à l'approche (200 px). Safari / iPhone : lecture adaptative HLS (commence petit,
     monte si la connexion le permet). Ailleurs : la plus petite version MP4 assez nette (largeur affichée × min(densité, 1,5)) ;
     480p en mode économie de données. Si une version manque, on revient à celle donnée par Shopify. Pause hors de l'écran. */
  function videos(racine) {
    var vs = [].slice.call((racine || document).querySelectorAll('video.bz-video__v[data-v1080]'));
    if (!vs.length) return;
    var eco = navigator.connection && navigator.connection.saveData;
    function choix(v) {
      if (v.dataset.hls && v.canPlayType('application/vnd.apple.mpegurl')) return v.dataset.hls;
      var besoin = (v.clientWidth || 300) * Math.min(window.devicePixelRatio || 1, 1.5);
      if (eco || besoin <= 270) return v.dataset.v480;
      if (besoin <= 404) return v.dataset.v720;
      return v.dataset.v1080;
    }
    function charge(v) { if (v.bzPret) return; v.bzPret = true;
      if (v.dataset.poster) v.poster = v.dataset.poster;
      v.addEventListener('error', function () { if (v.src.indexOf(v.dataset.v1080) < 0) { v.src = v.dataset.v1080; joue(v); } }, { once: true });
      v.src = choix(v) || v.dataset.v1080;
      if (v.hasAttribute('data-auto') && reduit) { v.removeAttribute('loop'); v.setAttribute('controls', ''); } }
    function joue(v) { if (!v.hasAttribute('data-auto') || reduit || v.bzStop || !v.bzVue) return;
      var p = v.play(); if (p && p.catch) p.catch(function (e) { if (e && e.name === 'NotAllowedError') v.setAttribute('controls', ''); }); }
    function bouton(v) { var b = v.parentElement.querySelector('.bz-video__pause'); if (!b) return;
      if (reduit) { b.hidden = true; return; }
      b.addEventListener('click', function () { v.bzStop = !v.bzStop; b.setAttribute('aria-pressed', v.bzStop ? 'true' : 'false');
        b.setAttribute('aria-label', v.bzStop ? 'Relancer la vidéo' : 'Mettre la vidéo en pause'); if (v.bzStop) v.pause(); else { charge(v); joue(v); } }); }
    vs.forEach(bouton);
    if (!('IntersectionObserver' in window)) { vs.forEach(function (v) { v.bzVue = true; charge(v); joue(v); }); return; }
    // 1) chargement à l'approche (200 px) ; 2) lecture seulement quand la vidéo est visible à 60 % (une seule à la fois sur téléphone)
    var proche = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) charge(e.target); }); }, { rootMargin: '800px 200px' });
    var vue = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; v.bzVue = e.isIntersecting;
      if (e.isIntersecting) { charge(v); joue(v); } else if (!v.paused) v.pause(); }); }, { threshold: 0.6 });
    vs.forEach(function (v) { proche.observe(v); vue.observe(v); });
  }

  /* Étiquettes de prix sur les objets du héros (12/10) : position en % de l'image, recalculée selon le cadrage (object-fit: cover +
     object-position) ; sur téléphone, une étiquette qui tomberait sur le texte est masquée. */
  function etiquettes(racine) {
    [].slice.call((racine || document).querySelectorAll('[data-bz-tags]')).forEach(function (z) {
      var slide = z.parentElement, img = slide.querySelector(':scope > img'); if (!img) return;
      function place() {
        var nw = img.naturalWidth, nh = img.naturalHeight; if (!nw) return;
        var bw = img.clientWidth, bh = img.clientHeight, k = Math.max(bw / nw, bh / nh), dw = nw * k, dh = nh * k;
        var pos = getComputedStyle(img).objectPosition.split(' '), px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || '50%') / 100;
        var ox = img.offsetLeft + (bw - dw) * px, oy = img.offsetTop + (bh - dh) * py;
        var texte = slide.querySelector('.bz-hero__contenu > div'), rt = texte ? texte.getBoundingClientRect() : null, rs = slide.getBoundingClientRect();
        [].slice.call(z.querySelectorAll('.bz-tag')).forEach(function (t) {
          var x = ox + dw * (+t.dataset.x) / 100, y = oy + dh * (+t.dataset.y) / 100;
          t.style.left = x + 'px'; t.style.top = y + 'px';
          var dehors = x < 8 || x > slide.clientWidth - 8 || y < 8 || y > slide.clientHeight - 8, gene = false;
          if (rt && !dehors) { var tx = rs.left + x, ty = rs.top + y; gene = tx > rt.left - 12 && tx < rt.right + 12 && ty > rt.top - 30 && ty < rt.bottom + 12; }
          t.hidden = dehors || gene;
        });
      }
      if (img.complete) place(); else img.addEventListener('load', place, { once: true });
      addEventListener('resize', place); if ('ResizeObserver' in window) new ResizeObserver(place).observe(slide);
    });
  }

  function init(racine) {
    etiquettes(racine);
    videos(racine);
    (racine || document).querySelectorAll('[data-bz-hero]').forEach(heros);
    (racine || document).querySelectorAll('.bz-glisse').forEach(glisse);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-bz-onglet]') : null;
    if (t) {
      var box = t.closest('.bz-incontournable');
      box.querySelectorAll('[data-bz-onglet]').forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
        var pan = document.getElementById(x.getAttribute('aria-controls')); if (pan) pan.hidden = !on;
      });
      return;
    }
    var c = e.target.closest ? e.target.closest('[data-bz-code]') : null;
    if (c) {
      var code = c.getAttribute('data-bz-code');
      try { navigator.clipboard.writeText(code).catch(function () {}); } catch (err) {}
      c.textContent = 'Copié'; c.classList.add('is-copie');
      setTimeout(function () { c.textContent = code; c.classList.remove('is-copie'); }, 1800);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  /* éditeur de thème : sections rechargées */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
